import React, { useState } from "react";
import SideNav, { NavItem, NavIcon, NavText } from "@trendmicro/react-sidenav";
import "@trendmicro/react-sidenav/dist/react-sidenav.css";
import { connect } from "react-redux";
import { Spinner } from "react-bootstrap";
import "./styles/backoffice.scss";
import { useLocation, useNavigate } from "react-router-dom";
import { logout } from "../ApiCalls/authentication";
import { userLogout } from "../Redux/modules/auth";
// import { browserHistory } from 'react-router';

function mapDispatchToProps(dispatch) {
  return {
    userLogout: () => dispatch(userLogout()),
  };
}

const select = (state) => {
  return {
    user: state.auth.user,
  };
};

function SidebarMenuComponent(props) {
  const [signingOut, setSigningOut] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  async function handleLogout() {
    setSigningOut(true);

    try {
      // L-01 (MA-06): the JWT lives in an httpOnly cookie now — logout() sends it
      // automatically and the backend clears the cookie on its end.
      await logout();
      props.userLogout();
      navigate("/login");
    } catch (error) {
      console.error("Logout error:", error);
      // Even if there's an error, clear state and navigate
      props.userLogout();
      navigate("/login");
    } finally {
      setSigningOut(false);
    }
  }

  return (
    <div className="sidebar-menu-component">
      <SideNav
        onSelect={(selected) => {
          console.log("SELECTED");
          console.log(selected);
          if (location.pathname !== selected) navigate(selected);
        }}
      >
        <SideNav.Toggle />
        <SideNav.Nav defaultSelected={location.pathname}>
          {/* Empresas section */}
          <NavItem eventKey="/backoffice/mantisBusinesses">
            <NavIcon>
              <i className="fas fa-building" style={{ fontSize: "1.75em" }} />
            </NavIcon>
            <NavText>Empresas</NavText>
          </NavItem>

          {/* New Agentes section */}
          <NavItem eventKey="/backoffice/agentes">
            <NavIcon>
              <i className="fas fa-user-tie" style={{ fontSize: "1.75em" }} />
            </NavIcon>
            <NavText>Agentes</NavText>
          </NavItem>

          {/* LLM Models section */}
          <NavItem eventKey="/backoffice/llm-models">
            <NavIcon>
              <i className="fas fa-brain" style={{ fontSize: "1.75em" }} />
            </NavIcon>
            <NavText>LLM Modelos</NavText>
          </NavItem>

          {/* System logs section */}
          <NavItem eventKey="/backoffice/system-logs">
            <NavIcon>
              <i
                className="fas fa-clipboard-list"
                style={{ fontSize: "1.75em" }}
              />
            </NavIcon>
            <NavText>Logs del sistema</NavText>
          </NavItem>

          {/* Logout section */}
          <NavItem
            onSelect={() => {
              handleLogout();
            }}
          >
            <NavIcon>
              {signingOut ? (
                <div style={{ marginTop: "5px" }}>
                  <Spinner animation="border" variant="warning" />
                </div>
              ) : (
                <i
                  className="fas fa-sign-out-alt"
                  style={{ fontSize: "1.75em" }}
                />
              )}
            </NavIcon>
            <NavText>{signingOut ? "" : "Cerrar sesión"}</NavText>
          </NavItem>
        </SideNav.Nav>
      </SideNav>
    </div>
  );
}

export default connect(select, mapDispatchToProps)(SidebarMenuComponent);
